@if (!isLoading) {
  <div class="account-content">
    <div class="account-container">
      <div class="page-title">
        <span class="font-bold-display-medium"> Mein Konto </span>
        @if (activeTab === 'account') {
          <button
            [disabled]="!formHasUnsavedChanges()"
            class="inwi-icon-text-button-medium-secondary"
            (click)="onSubmit()">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-floppy-disk"></i>
              </div>
              <div class="button-text">Änderungen Speichern</div>
            </div>
          </button>
        }
      </div>
      <div class="account-formular-container">
        <div class="header">
          <div class="avatar-container">
            <div class="avatar" [style]="avatarStyles">
              <div [style.display]="avatarLoaded ? 'block' : 'none'">
                <img
                  [src]="avatar"
                  alt="avatar"
                  class="avatar"
                  (error)="avatarLoaded = false"
                  (load)="avatarLoaded = true" />
              </div>
              @if (!avatarLoaded) {
                {{ getUserInitials() }}
              }
              <button class="edit-image-button" (click)="onOpenUploadDialog()">
                <i class="fa-regular fa-pen"></i>
              </button>
              <input
                type="file"
                #fileInput
                accept="image/*"
                (change)="onFileSelected($event)"
                style="display: none" />
            </div>
            <div class="flex-c gap-4">
              <span class="font-medium-title-large">
                {{
                  this.userForm.get('firstname').value +
                    ' ' +
                    this.userForm.get('lastname').value
                }}
              </span>
              <span>{{ this.userForm.get('jobTitle').value }}</span>
            </div>
          </div>
          <app-tab-menu
            class="align-self-stretch"
            [tabs]="tabs"
            [activeTab]="activeTab"
            (tabChange)="onTabChange($event)"></app-tab-menu>
        </div>
        @if (activeTab === 'account') {
          <form class="account-formular" [formGroup]="userForm">
            <div class="formular-row-2-inputs">
              <div class="input-simple flex-1-1-0">
                <label for="salutation" class="input-label">
                  Anrede{{
                    fieldRequired(userForm.get('salutation')) ? '*' : ''
                  }}
                </label>
                <p-select
                  id="salutation"
                  formControlName="salutation"
                  [options]="salutationOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Anrede auswählen..." />
                <app-error-message
                  [formField]="userForm.get('salutation')"></app-error-message>
              </div>
              <div class="input-simple flex-1-1-0 placeholder"></div>
            </div>
            <div class="formular-row-2-inputs">
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="firstname">
                  Vorname{{
                    fieldRequired(userForm.get('firstname')) ? '*' : ''
                  }}
                </label>
                <input
                  id="firstname"
                  class="input-field input-field-input"
                  type="text"
                  name="firstname"
                  autocomplete="given-name"
                  formControlName="firstname"
                  placeholder="Vorname" />
                <app-error-message
                  [formField]="userForm.get('firstname')"></app-error-message>
              </div>
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="lastname">
                  Nachname{{
                    fieldRequired(userForm.get('lastname')) ? '*' : ''
                  }}
                </label>
                <input
                  id="lastname"
                  class="input-field input-field-input"
                  type="text"
                  name="lastname"
                  autocomplete="family-name"
                  formControlName="lastname"
                  placeholder="Nachname" />
                <app-error-message
                  [formField]="userForm.get('lastname')"></app-error-message>
              </div>
            </div>
            <div class="formular-row-2-inputs">
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="street">
                  Straße{{ fieldRequired(userForm.get('street')) ? '*' : '' }}
                </label>
                <input
                  id="street"
                  class="input-field input-field-input"
                  type="text"
                  name="street"
                  formControlName="street"
                  placeholder="Straße" />
                <app-error-message
                  [formField]="userForm.get('street')"></app-error-message>
              </div>
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="houseNumber">
                  Hausnummer{{
                    fieldRequired(userForm.get('houseNumber')) ? '*' : ''
                  }}
                </label>
                <input
                  id="houseNumber"
                  class="input-field input-field-input"
                  type="text"
                  name="houseNumber"
                  formControlName="houseNumber"
                  placeholder="Hausnummer" />
                <app-error-message
                  [formField]="userForm.get('houseNumber')"></app-error-message>
              </div>
            </div>
            <div class="formular-row-2-inputs">
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="zipCode">
                  PLZ{{ fieldRequired(userForm.get('zipCode')) ? '*' : '' }}
                </label>
                <input
                  id="zipCode"
                  class="input-field input-field-input"
                  type="text"
                  name="zipCode"
                  formControlName="zipCode"
                  placeholder="PLZ" />
                <app-error-message
                  [formField]="userForm.get('zipCode')"></app-error-message>
              </div>
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="city">
                  Ort{{ fieldRequired(userForm.get('city')) ? '*' : '' }}
                </label>
                <input
                  id="city"
                  class="input-field input-field-input"
                  type="text"
                  name="city"
                  formControlName="city"
                  placeholder="Ort" />
                <app-error-message
                  [formField]="userForm.get('city')"></app-error-message>
              </div>
            </div>
            <div class="formular-row-2-inputs">
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="country">
                  Land{{ fieldRequired(userForm.get('country')) ? '*' : '' }}
                </label>
                <p-select
                  id="country"
                  formControlName="country"
                  [options]="countryOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Land auswählen..." />
                <app-error-message
                  [formField]="userForm.get('country')"></app-error-message>
              </div>
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="birthdate">
                  Geburtsdatum{{
                    fieldRequired(userForm.get('birthdate')) ? '*' : ''
                  }}
                </label>
                <p-datepicker
                  appendTo="body"
                  inputId="birthdate"
                  name="birthdate"
                  class="align-self-stretch"
                  formControlName="birthdate"
                  dateFormat="dd.mm.yy"
                  [maxDate]="maxDateBirthdate"
                  [minDate]="minDateBirthdate"
                  [defaultDate]="defaultDateBirthdate"
                  placeholder="TT.MM.JJJJ" />
                <app-error-message
                  [formField]="userForm.get('birthdate')"></app-error-message>
              </div>
            </div>
            <div class="formular-row-2-inputs">
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="email">
                  E-Mail{{ fieldRequired(userForm.get('email')) ? '*' : '' }}
                </label>
                <input
                  id="email"
                  class="input-field input-field-input"
                  type="text"
                  name="email"
                  formControlName="email"
                  placeholder="E-Mail" />
                <app-error-message
                  [formField]="userForm.get('email')"></app-error-message>
              </div>
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="phoneNumber">
                  Telefon{{
                    fieldRequired(userForm.get('phoneNumber')) ? '*' : ''
                  }}
                </label>
                <input
                  id="phoneNumber"
                  class="input-field input-field-input"
                  type="text"
                  name="phoneNumber"
                  formControlName="phoneNumber"
                  placeholder="Telefon" />
                <app-error-message
                  [formField]="userForm.get('phoneNumber')"></app-error-message>
              </div>
            </div>
            <div class="formular-row-2-inputs">
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="bedMember">
                  BED-Mitglied{{
                    fieldRequired(userForm.get('bedMember')) ? '*' : ''
                  }}
                </label>
                <div class="radio-buttons">
                  <label
                    for="bedYes"
                    class="inwi-radio font-regular-body-large">
                    <input
                      id="bedYes"
                      type="radio"
                      [value]="true"
                      formControlName="bedMember" />
                    <span> Ja </span>
                  </label>
                  <label for="bedNo" class="inwi-radio font-regular-body-large">
                    <input
                      id="bedNo"
                      type="radio"
                      [value]="false"
                      formControlName="bedMember" />
                    <span> Nein </span>
                  </label>
                </div>
                <app-error-message
                  [formField]="userForm.get('bedMember')"></app-error-message>
              </div>
              <div class="input-simple flex-1-1-0">
                <label class="input-label" for="jobTitle">
                  Beruf{{ fieldRequired(userForm.get('jobTitle')) ? '*' : '' }}
                </label>
                <input
                  id="jobTitle"
                  class="input-field input-field-input"
                  type="text"
                  name="jobTitle"
                  formControlName="jobTitle"
                  placeholder="Beruf" />
                <app-error-message
                  [formField]="userForm.get('jobTitle')"></app-error-message>
              </div>
            </div>
            @if (userForm.get('bedMember').value === true) {
              <div class="formular-row-2-inputs">
                <div class="input-simple flex-1-1-0">
                  <label class="input-label" for="bedMemberNumber">
                    BED-Mitgliedsnummer{{
                      fieldRequired(userForm.get('bedMemberNumber')) ? '*' : ''
                    }}
                  </label>
                  <input
                    id="bedMemberNumber"
                    class="input-field input-field-input"
                    type="text"
                    name="bedMemberNumber"
                    formControlName="bedMemberNumber"
                    placeholder="Mitgliedsnummer" />
                  <app-error-message
                    [formField]="
                      userForm.get('bedMemberNumber')
                    "></app-error-message>
                </div>
                <div class="input-simple flex-1-1-0 placeholder"></div>
              </div>
            }
          </form>
        } @else if (activeTab === 'bookings') {
          <app-user-bookings></app-user-bookings>
        } @else if (activeTab === 'appointments') {
          <app-user-appointments></app-user-appointments>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="loading-wrapper">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="32">
    </mat-progress-spinner>
  </div>
}
